module.exports = __webpack_public_path__ + "static/media/trustpilot-widget-logo.2b6912bd.png";